module.exports = __webpack_public_path__ + "static/img/customer2.6573d960.png";